import {z} from 'zod';
import {checkValidPhoneNumber} from '@/libs/string.util';

export const IMAGE_FILE_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/heic'];

export const ZodValidator = {
	fullName: (v, minLength) => z
			.string()
			.trim()
			.min(minLength, v('minLength', { val: minLength })),
	email: (v, minLength) => z
			.string()
			.trim()
			.email({message: v('invalidEmail')})
			.min(minLength, v('minLength', { val: minLength })),
	emailOptional: (v, minLength) => z
			.string()
			.trim()
			.transform(value => (value === '' ? null : value))
			.nullable()
			.or(
					z.string()
							.email({ message: v('invalidEmail') })
							.min(minLength, v('minLength', { val: minLength }))
			),
	telNumber: (v) => z
			.string()
			.trim()
			.refine((value) => checkValidPhoneNumber(value), v('invalidTelNumber')),
	telNumberOptional: (v) => z
			.string()
			.trim()
			.nullable()
			.transform(value => value === '' ? null : value)
			.refine((value) => !value || checkValidPhoneNumber(value), v('invalidTelNumber')),
	stringOptional: () => z
			.string()
			.trim()
			.nullable()
			.transform(value => value === '' ? null : value),
	password: (v, minLength) => z
			.string()
			.trim()
			.min(minLength, v('minLength', { val: minLength })),
	passwordOptional: (v, minLength) => {
		const validate = z
				.string()
				.trim()
				.nullable()
				.transform(value => value === '' ? null : value);
		if (minLength) {
			validate.refine((value) => !value || value.length >= minLength, v('minLength', { val: minLength }));
		}
		return validate;
	},
	image: (v, maxSize = 200, imageTypes = IMAGE_FILE_TYPES) => z
			.any()
			.refine((files) => files?.[0]?.size <= maxSize, v('maxFileSize', { size: maxSize / 1000000 }))
			.refine((files) => imageTypes.includes(files?.[0]?.type), v('supportImageTypes')),
	stringRequired: (v, minLength) => z
			.string()
			.trim()
			.min(minLength, v('minLength', { val: minLength })),
	rating: (v) => z
			.number()
			.min(1, v('min', { val: 1 }))
			.max(5, v('max', { val: 5 }))
}
